import TabRealisasiAlatMesin from './TabRealisasiAlatMesin';

export default TabRealisasiAlatMesin;
